import React from 'react'
import Dashboard from '../dashboard'
import AnalyticsView from './page'

const Analytics = () => {
  return <Dashboard component={<AnalyticsView />} />
}

export default Analytics
